/* Deferred vendor lifecycle with real readiness, bounded recovery and late healing. */
(function () {
  function mount(root) {
    if (root.dataset.ptLocatorMounted) return;
    root.dataset.ptLocatorMounted = 'true';
    var probeKey='locator:'+root.id;
    var container = root.querySelector('#storemapper');
    var loading = root.querySelector('[data-pt-locator-loading]');
    var fallback = root.querySelector('[data-pt-locator-fallback]');
    var script, timer, retryTimer, attempts = 0, onlineRetried = false, observing = false;
    var health = window.ptStorefrontHealth = window.ptStorefrontHealth || {};
    function signal(status) {
      if (root.dataset.ptLocatorState === status) return;
      root.dataset.ptLocatorState = status; health.locator = status;
      loading.hidden = status === 'ready' || status === 'degraded' || status === 'exhausted';
      fallback.hidden = status !== 'degraded' && status !== 'exhausted';
      document.dispatchEvent(new CustomEvent('pt:storefront-health', { detail: { component: 'locator', status: status, attempts: attempts } }));
      if (window.ptRecoveryScheduler) {
        if (status === 'ready') window.ptRecoveryScheduler.cancel(probeKey);
        if (status === 'exhausted') window.ptRecoveryScheduler.schedule(probeKey,function(){
          if (!root.isConnected) return window.ptRecoveryScheduler.cancel(probeKey);
          if (root.dataset.ptLocatorState !== 'exhausted') return; attempts=0;start();
        });
      }
      if (status === 'exhausted') console.error('[PT storefront] Store locator recovery exhausted');
    }
    function ready() {
      var search = container.querySelector('#storemapper-zip');
      var map = container.querySelector('.gm-style, .mapboxgl-canvas');
      var stores = container.querySelector('.storemapper-storelink, [id^="storemapper-listing-"]');
      var data = window.Storemapper && window.Storemapper.stores;
      stores = stores || (data && Array.isArray(data.features) && data.features.length > 0);
      if (search && !search.disabled && map && stores && !container.querySelector('.gm-err-container, .gm-err-message')) {
        window.clearTimeout(timer); window.clearTimeout(retryTimer); retryTimer = null;
        signal('ready'); observer.disconnect(); observing = false; return true;
      }
      return false;
    }
    var observer = new MutationObserver(ready);
    function failed() {
      if (ready()) return;
      window.clearTimeout(timer);
      signal(attempts < 3 ? 'degraded' : 'exhausted');
      if (attempts < 3 && !retryTimer) retryTimer = window.setTimeout(function () { retryTimer = null; start(); }, attempts * 2000);
      // Do not disconnect on failure: a late vendor response must still heal.
    }
    function start() {
      window.clearTimeout(timer); window.clearTimeout(retryTimer); retryTimer = null;
      attempts++; signal('loading');
      if (!observing) { observer.observe(container, { childList: true, subtree: true }); observing = true; }
      timer = window.setTimeout(failed, 12000);
      if (window.Storemapper && typeof window.Storemapper.start === 'function') {
        // Restart through the vendor's lifecycle instead of executing another
        // copy of its script and multiplying global callbacks and listeners.
        try { window.Storemapper.start(); } catch (error) { failed(); }
      } else {
        if (script) script.remove();
        script = document.createElement('script'); script.async = true;
        script.src = 'https://www.storemapper.co/js/widget.js';
        script.dataset.storemapperStart = '2021,05,20'; script.dataset.storemapperId = '10721';
        script.onerror = failed;
        document.head.appendChild(script);
      }
    }
    function activate() { if (!attempts) start(); }
    if ('IntersectionObserver' in window) {
      var visibility = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { visibility.disconnect(); activate(); }
      }, { rootMargin: '0px' }); visibility.observe(root);
    } else if (document.readyState === 'complete') activate();
    else window.addEventListener('load', activate, { once: true });
    document.querySelectorAll('a[href="#wtb-finder"]').forEach(function (link) { link.addEventListener('click', activate); });
    root.querySelector('[data-pt-locator-retry]').addEventListener('click', function () {
      if (root.dataset.ptLocatorState === 'loading' || root.dataset.ptLocatorState === 'ready') return;
      attempts = 0; start();
    });
    window.addEventListener('online', function () {
      if (window.ptRecoveryScheduler) return;
      if (!onlineRetried && (root.dataset.ptLocatorState === 'degraded' || root.dataset.ptLocatorState === 'exhausted')) { onlineRetried = true; attempts = 0; start(); }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      if (window.ptRecoveryScheduler) window.ptRecoveryScheduler.cancel(probeKey);
      observer.disconnect(); window.clearTimeout(timer); window.clearTimeout(retryTimer);
    });
  }
  document.querySelectorAll('[data-pt-locator]').forEach(mount);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-pt-locator]').forEach(mount); });
})();
